<template lang="pug">
  validation-observer(ref='conflito', tag='div', v-if="conflito")
    el-card
      el-row(:gutter="20")
        el-col(:span="24")
          app-divider(
            label="Dados do Conflito",
            :showBorder="true",
            :required="true"
          )
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Número do Processo:
          span.info-label {{conflito.numeroProcesso}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Município:
          span.info-label {{conflito.municipio ? conflito.municipio.nome : '-'}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Número de Famílias:
          span.info-label {{conflito.numeroFamilias}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Jurisdição:
          span.info-label {{conflito.jurisdicaoFormatada}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Data de Cadastro:
          span.info-label {{conflito.dataCriacaoFormatada}}
        el-col.margin-top(:md="6", :sm="12")
          span.info-title Origem:
          span.info-label {{conflito.origemFormatada}}
        el-col.margin-top(:span="24", v-if="conflito.geometrias && conflito.geometrias.length > 0")
            app-resumo-mapa(
              :idMapa="'id-mapa-localizacao-' + conflito.id"
              :height="30"
              :localizacoes="conflito.geometrias",
              :isVisualizarCadastro="true"
            )
            .flex-button
              div.btn
                el-button(
                  @click="downloadShape(conflito.id)"
                )
                  i.fal.fa-download
                  | &nbsp Download do shapefile
    el-card.top-margin
      el-row.marginLeft
        el-col(:span="24")
          app-divider(
            label="Responder Solicitação",
            :showBorder="true",
            required
          )
        el-col(:span="24").margin-top
          validation-provider(mode="lazy", rules="required", v-slot="{ errors }", name="Responder Solicitação")
            app-label(label="Resposta: ", :required="true")
            el-input.input(v-model="conflito.resposta", type="textarea", :rows="4", :class="{'erro' : errors.length}")
            span.help.erro {{ errors[0] }}
        el-col(:span="24")
          app-radios-tramitacao(
            :radios="radios",
            :isDecisao="true"
            @changeRadio="changeRadio"
          )
    el-row
      el-col.flex(:span="24")
        el-button.btn(type="default", size="small", @click="cancelar")
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(type="success", size="small", @click="salvarCadastro")
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
</template>

<script>
import axios from '@/utils/api'
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppResumoMapa from '@/components/resumo/AppResumoMapa'
import AppLabel from '@/components/AppLabel'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'

export default {

  name: 'ValidarShapeConflito',

  components: {
    AppResumoMapa,
    AppLabel,
    AppRadiosTramitacao
  },

  mixins: [AppNotificacao],

  props: {
    id: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      conflito: null,
      decisao: null,
      radios: [
        { nome: 'Aprovar arquivo', valor: 'APROVADO' },
        { nome: 'Reprovar arquivo', valor: 'REPROVADO' }
      ]
    }
  },
  async mounted () {
    this.conflito = await this.getConflitoById(this.id)
    this.conflito.geometrias = this.conflito.geometrias.map(g => (JSON.parse(g)))
  },

  methods: {
    ...mapActions({
      getConflitoById: 'conflito/getConflitoById',
      saveConflito: 'conflito/saveConflito',
      enviarArquivarConflito: 'conflito/enviarArquivarConflito',
      arquivarConflito: 'conflito/arquivarConflito',
      finalizarConflito: 'conflito/finalizarConflito'
    }),
    changeRadio (value) {
      this.decisao = value.acao
    },
    cancelar () {
      this.confirmBox(
        this.$messages.CANCECAR_CONFLITO,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.go(-1)
        },
        () => {}
      )
    },
    async salvarCadastro () {
      const valido = await this.$refs.conflito.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.VALIDATION_FAIL)
        return
      }
      this.confirmBox(
        this.decisao === 'APROVADO' ? this.$messages.APROVADO_CONFLITO_CONFIRM : this.$messages.REPROVADO_CONFLITO_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          const cadastro = {
            ...this.conflito
          }
          this.saveConflito(cadastro).then(async () => {
            if (this.decisao === 'APROVADO') {
              await this.finalizarConflito(this.conflito.id)
            } else {
              await this.enviarArquivarConflito(this.conflito.id)
            }
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.decisao === 'APROVADO' ? this.$messages.APROVADO_CONFLITO : this.$messages.REPROVADO_CONFLITO
            )
            this.$router.go(-1)
          })
        },
        () => {}
      )
    },
    async downloadShape (id) {
      await axios({
        method: 'GET',
        url: `api/v1/conflitos/shape/exportar/${id}`,
        responseType: 'blob'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .margin {
    margin: 10px;
  }
  .margin-titulo {
    padding-top: 20px;
    padding-left: 7px;
  }
  .paddingRight {
    position: absolute;
    padding-right: 4px;
    right: 0;
  }
  .flex {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
  }
  .marginLeft {
    margin: 10px;
    margin-top: 0;
  }
  .erro {
    color: red;
  }
  .help.erro {
    font-size: 12px;
  }

  .top-margin {
    margin-top: 10px;
  }

  .info-title {
    font-size: 14px;
    font-weight: bold;
    margin-right: 5px;
  }

  .info-label {
    font-size: 14px;
  }
  .margin-top {
    margin-top: 10px;
  }
  .flex-button {
    display: flex;
    justify-content: end;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/ValidarShapeConflito.vue